import { Card, Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import NationalityEdit from './NationalityEdit';

const NationalityShow = () => {

    let {id} = useParams();

    return (
        
        <Container fluid>
            <Row>
                <Col>
                    <Card>
                        <NationalityEdit id={id}/>
                    </Card>
                </Col>
            </Row>
        </Container>
    );

}

export default NationalityShow;